import { WithTooltip } from './Tooltip.js';
import { Icon, type IconName } from '../Icon.js';

/* Toggle redondo de solo icono (spec V2 — ej. seguimiento en la fila de
 * metadatos del email): activo = relleno tenue + color de acento; inactivo =
 * contorno gris. El tooltip/title dice la ACCIÓN del click, no el estado. */

export interface IconPillToggleProps {
  icon: IconName;
  /** Icono cuando está activo (default: el mismo). */
  activeIcon?: IconName;
  active: boolean;
  /** Texto de la acción del click — va a tooltip, title y aria-label. */
  label: string;
  onClick: () => void;
  disabled?: boolean;
  tooltipAlign?: 'left' | 'right' | 'center';
}

export function IconPillToggle({
  icon,
  activeIcon,
  active,
  label,
  onClick,
  disabled = false,
  tooltipAlign = 'right',
}: IconPillToggleProps) {
  return (
    <WithTooltip label={label} align={tooltipAlign}>
      <button
        type="button"
        title={label}
        aria-label={label}
        aria-pressed={active}
        disabled={disabled}
        onClick={onClick}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 'var(--evo-pill-h-sm)',
          height: 'var(--evo-pill-h-sm)',
          padding: 0,
          color: active ? 'var(--evo-amber)' : 'var(--evo-fg-3)',
          background: active ? 'var(--evo-fill-warning)' : 'transparent',
          border: `var(--evo-bw-tag) solid ${active ? 'var(--evo-amber)' : 'var(--evo-fg-3)'}`,
          borderRadius: 'var(--evo-r-pill)',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          boxSizing: 'border-box',
          flexShrink: 0,
          transition: 'color 120ms linear, background 120ms linear, border-color 120ms linear',
        }}
      >
        <Icon name={active ? (activeIcon ?? icon) : icon} size={11} />
      </button>
    </WithTooltip>
  );
}
